<app-nav [titulo]="office ? 'Modificar oficina ' + office.nombre : 'Nueva oficina'" [descripcion]="office ? 'Aquí podrá ver todos los detalles de la oficina seleccionada y modificarlos.' : 'Por favor complete todos los datos de la nueva oficina.'">
    <div class="edit-office basic-avm-editor">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab [label]="office ? 'Edición' : 'Creación manual'">
                <mat-horizontal-stepper class="form-stepper" [linear]="!this.office" #stepper>
                    <mat-step [stepControl]="generalSectionFG">
                        <form class="form-step" [formGroup]="generalSectionFG" (ngSubmit)="generalSectionFG.valid && stepper.next()">
                            <ng-template matStepLabel>Información general</ng-template>
                            <h3 class="form-step-title">
                                Información general
                            </h3>
                            <span class="form-step-description">
                                Para comenzar complete la información de la oficina.
                            </span>
                            <div class="form-line">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Nombre</mat-label>
                                    <input matInput formControlName="nombre">
                                    <mat-error *ngIf="generalSectionFG.controls['nombre'].hasError('required')">
                                        Por favor ingrese un nombre
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Nro. sucursal</mat-label>
                                    <input matInput formControlName="sucursal" autocomplete="off">
                                    <mat-error *ngIf="generalSectionFG.controls['sucursal'].hasError('required')">
                                        Por favor ingrese un número de sucursal
                                    </mat-error>
                                    <mat-error *ngIf="generalSectionFG.controls['sucursal'].hasError('notAvailable')">
                                        El valor seleccionado no está disponible
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="form-line">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Teléfono fijo</mat-label>
                                    <app-phone-input formControlName="telefonoFijo"></app-phone-input>
                                    <mat-error *ngIf="generalSectionFG.controls['telefonoFijo'].hasError('required')">
                                        Por favor ingrese un teléfono
                                    </mat-error>
                                    <mat-hint>Ejemplo: + 54 - 911 - 11112222</mat-hint>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>CUIT/CUIL</mat-label>
                                    <app-cuit-input formControlName="cuit"></app-cuit-input>
                                    <mat-error *ngIf="generalSectionFG.controls['cuit'].hasError('required')">
                                        Por favor ingrese un cuit
                                    </mat-error>
                                    <mat-error *ngIf="generalSectionFG.controls['cuit'].hasError('minlength') || generalSectionFG.controls['cuit'].hasError('maxlength')">
                                        El cuit debe tener 11 dígitos
                                    </mat-error>
                                    <mat-error *ngIf="generalSectionFG.controls['cuit'].hasError('number')">
                                        El cuit debe ser un número
                                    </mat-error>
                                    <mat-hint>Sin guiones, ejemplo: 20123456781</mat-hint>
                                </mat-form-field>
                            </div>
                            <div class="form-line">
                                 <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Oficina remax ID</mat-label>
                                    <input matInput formControlName="idRemax" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="form-step-buttons">
                                <button mat-raised-button color="primary" class="garantor-button">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOffice()" *ngIf="office">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [stepControl]="addressSectionFG">
                        <form class="form-step" [formGroup]="addressSectionFG" (ngSubmit)="addressSectionFG.valid && stepper.next()">
                            <ng-template matStepLabel>Dirección</ng-template>
                            <h3 class="form-step-title">
                                Dirección
                            </h3>
                            <span class="form-step-description">
                                Complete los datos de la dirección de la oficina.
                            </span>
                            <app-address-form [formGroup]="addressSectionFG"></app-address-form>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="primary" class="garantor-button">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOffice()" *ngIf="office">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [stepControl]="responsibleSectionFG">
                        <form class="form-step" [formGroup]="responsibleSectionFG" (ngSubmit)="responsibleSectionFG.valid && stepper.next()">
                            <ng-template matStepLabel>Broker</ng-template>
                            <h3 class="form-step-title">
                                Broker
                            </h3>
                            <span class="form-step-description">
                                Gerente de la oficina.
                            </span>
                            <div class="form-line">
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Nombre del Broker</mat-label>
                                    <input matInput formControlName="nombreResponsable">
                                    <mat-error *ngIf="responsibleSectionFG.controls['nombreResponsable'].hasError('required')">
                                        Por favor ingrese el nombre
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="garantor-form-field" appearance="outline">
                                    <mat-label>Apellido del responsable</mat-label>
                                    <input matInput formControlName="apellidoResponsable">
                                    <mat-error *ngIf="responsibleSectionFG.controls['apellidoResponsable'].hasError('required')">
                                        Por favor ingrese el apellido
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>Teléfono celular</mat-label>
                                <app-phone-input formControlName="celular"></app-phone-input>
                                <mat-error *ngIf="responsibleSectionFG.controls['celular'].hasError('required')">
                                    Por favor ingrese el celular
                                </mat-error>
                            </mat-form-field>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="primary" class="garantor-button">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOffice()" *ngIf="office">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step>
                        <form class="form-step services-selector-form" [formGroup]="">
                            <ng-template matStepLabel>Servicios</ng-template>
                            <h3 class="form-step-title">
                                Servicios
                            </h3>
                            <span class="form-step-description">
                                Seleccione los servicios disponibles para la oficina.
                            </span>
                            <div class="services-selector">
                                <app-data-table
                                    [rows]="servicesOverrides"
                                    [columns]="getServicesTableColumns()"
                                    overflow="auto"
                                    maxWidth="calc(100vw - 370px)"
                                    minWidth="0"
                                ></app-data-table>
                                <button mat-raised-button color="primary" type="button" class="garantor-button mini add-service" (click)="openServicesSelectorModal()">Seleccionar servicios</button>
                            </div>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="primary" class="garantor-button" (click)="stepper.next()">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOffice()" *ngIf="office">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [stepControl]="credentialsSectionFG">
                        <form class="form-step" [formGroup]="credentialsSectionFG" (ngSubmit)="(credentialsSectionFG.valid || office) && stepper.next()">
                            <ng-template matStepLabel>Credenciales</ng-template>
                            <h3 class="form-step-title">
                                Credenciales
                            </h3>
                            <span class="form-step-description">
                                Complete la información para que el broker pueda ingresar a la plataforma.
                            </span>
                            <mat-form-field class="garantor-form-field" appearance="outline">
                                <mat-label>E-Mail</mat-label>
                                <input matInput formControlName="email">
                                <mat-error *ngIf="credentialsSectionFG.controls['email'].hasError('required')">
                                    Por favor ingrese el email
                                </mat-error>
                                <mat-error *ngIf="credentialsSectionFG.controls['email'].hasError('email')">
                                    Por favor ingrese un email válido
                                </mat-error>
                                <mat-hint>
                                    Este email será utilizado para notificaciones
                                </mat-hint>
                            </mat-form-field>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="primary" class="garantor-button">Siguiente</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOffice()" *ngIf="office">Guardar y salir</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step>
                        <div class="form-step details-form-step">
                            <ng-template matStepLabel>Resumen</ng-template>
                            <h3 class="form-step-title">
                                Resumen
                            </h3>
                            <span class="form-step-description">
                                Por favor verifique los datos de la nueva oficina y presione confirmar.
                            </span>
                            <div class="office-details-content-container">
                                <app-office-details-content [office]="getResultingOffice()"></app-office-details-content>
                            </div>
                            <div class="form-step-buttons">
                                <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                                <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createOffice()">Confirmar</button>
                            </div>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </mat-tab>
            <mat-tab label="Creación masiva" *ngIf="!office">
                <app-bulk-creator style="width: 100%;" [columnMaps]="bulkCreatorColumnMaps" [getErrorsFn]="getBulkCreatorErrors" [submitFn]="bulkCreatorSubmit"></app-bulk-creator>
            </mat-tab>
        </mat-tab-group>
    </div>
</app-nav>
<ng-template #editServiceFieldColumnTemplate let-value="value" let-rowIndex="rowIndex">
    <mat-form-field class="garantor-form-field no-bottom-spacing-form-field no-label" appearance="outline">
        <input matInput [(ngModel)]="servicesOverrides[rowIndex][value.key]" placeholder="Default: {{ value.default }}" type="number">
    </mat-form-field>
</ng-template>
